import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const departmentApi = generateNomenApi<{ name: string }>(`/departments`); // TODO SEPARATE department from nomen

export const departmentOptions = generateNomenOptions('department', departmentApi);
